<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div @click="backPage" class="mt-racede-fff-back flex-row-align">
        <i class="el-icon-arrow-left"></i>返回
      </div>
      <div class="text item">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm" style="margin-top: 16px;">
          <el-form-item label="用户搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入用户手机号/姓名搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="historyId"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderNo"
            label="订单编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="realPayMoney"
            label="订单金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="paySuccessTime"
            label="支付时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryUserInvoiceHistoryOrderPageList  } from '@/api/invoice'
export default {
  name: 'InvoiceOrder',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      let dataId = that.dataId
      queryUserInvoiceHistoryOrderPageList({ historyId: dataId, orderNo: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/invoice/Order.vue